<script setup>
import MultiSelect from "primevue/multiselect";
import Button from "primevue/button";
import Dialog from "primevue/dialog";
import { onMounted, ref } from "vue";

const props = defineProps([
    'form',
    'devices',
]);

const addVisible = ref(false)
const devicesMap = ref({})
const availableDevices = ref([])
const newDevices = ref([])

const setAvailableDevices = () => {
    var tempDevicesMap = Object.assign({}, devicesMap.value)

    for (var i in props.form.devices) {
        var key = props.form.devices[i].uuid

        delete tempDevicesMap[key]
    }

    availableDevices.value = Object.values(tempDevicesMap).filter(item => item)
}

const addDevices = () => {
    for (var i in newDevices.value) {
        props.form.devices.push(devicesMap.value[newDevices.value[i]])
    }

    newDevices.value = []

    setAvailableDevices()

    addVisible.value = false
}

const open = () => {
    addVisible.value = true
}

onMounted(() => {
    for (var i in props.devices) {
        devicesMap.value[props.devices[i].uuid] = props.devices[i]
    }

    setAvailableDevices()
})

defineExpose({
    open,
    setAvailableDevices,
})

</script>
<template>
    <Dialog v-model:visible="addVisible"
            header="Gerät hinzufügen"
            :style="{ width: '25rem' }"
            modal>
        <div class="mb-7">
            <MultiSelect v-model="newDevices"
                         :options="availableDevices"
                         option-label="name"
                         option-value="uuid"
                         class="w-full md:w-14rem" />
        </div>

        <div class="flex justify-end gap-2">
            <Button type="button" label="Abbrechen" severity="secondary" @click="addVisible = false"></Button>
            <Button type="button" label="Hinzufügen" @click="addDevices"></Button>
        </div>
    </Dialog>
</template>
